export { default } from './ResultSettings'
